module.exports = __webpack_public_path__ + "img/partners.3612931c.svg";